module.exports = __webpack_public_path__ + "img/new_folding_door.d32b58c6.png";